import React from 'react';

import { css } from '@emotion/css';
import { Button, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FontSizes } from '@/assets/fonts.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { QueryErrorFallbackProps } from '@/queries/QueryAwait.tsx';
import { ContactSupport } from '@/uiKit/molecules/ContactSupport.tsx';

export const CriticalErrorPage: React.FC<QueryErrorFallbackProps> = ({
  reset,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  return (
    <div id="main-loading-screen" className={styles.container}>
      <Typography variant="h6" className={styles.text}>
        {t('errors.unknownError')}
      </Typography>
      <div className={styles.explain}>
        <Typography variant="body" className={styles.text}>
          {`${t('errors.waitAFewMinutes')} ${t('errors.or')}`}
        </Typography>
        <ContactSupport className={styles.text} component="p" />
      </div>
      <Button variant="text" onClick={reset} className={styles.button}>
        {t('button.tryAgain')}
      </Button>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
    gap: theme.spacing(16),
  }),
  explain: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
  text: css`
    color: ${theme.palette.grey[100]};
    line-height: ${FontSizes.h5};
    text-align: center;
  `,
  button: css({
    color: theme.palette.grey[100],
    textDecoration: 'underline',
  }),
});
